module.exports = __webpack_public_path__ + "static/media/tpn-ce-mockup-2.7e625abc.jpg";